import React from 'react';
import { Link } from 'react-router-dom';

const Book = ({ book }) => {
    const { id, name, logo } = book;
    return (
        <div className="card w-full  m-5 sm:bg-slate-200  shadow-xl ">
            <figure><img className='bg-slate-200' alt='img' src={logo} /></figure>
            <div className="p-4 bg-slate-200">
                <div className=" md:flex md:justify-between ">
                    <h2 className="card-title"><small>{name}</small></h2>
                    <div className="md:w-26">
                        <Link to={`/quiz/${id}`}><button className="btn md:btn-xs btn-primary sm:w-full sm:btn-md">Start Quize
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class=" h-4 w-2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                            </svg>
                        </button></Link>
                    </div>
                </div>
            </div>
        </div >

    );
};

export default Book;